







import Vue from 'vue'

export default Vue.extend({
  props: {
    cutHeight: {
      type: Number,
      required: true,
    },
    cutWidth: {
      type: Number,
      required: true,
    },
    cutTopLeft: {
      type: Boolean,
      default: false,
    },
    cutBottomLeft: {
      type: Boolean,
      default: false,
    },
    cutBottomRight: {
      type: Boolean,
      default: false,
    },
    cutTopRight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssVars() {
      return {
        '--cut-height': this.cutHeight + 'px',
        '--cut-width': this.cutWidth + 'px',

        '--top': this.cutTop ? 0 : 'unset',
        '--right': this.cutLeft ? 'unset' : 0,
        '--bottom': this.cutTop ? 'unset' : 0,
        '--left': this.cutLeft ? 0 : 'unset',

        '--margin-top': this.cutTop ? '-1px' : 'auto',
        '--margin-right': this.cutLeft ? 'auto' : '-1px',
        '--margin-bottom': this.cutTop ? 'auto' : '-1px',
        '--margin-left': this.cutLeft ? '-1px' : 'auto',

        '--cut-border-top': this.cutTop ? 0 : '1px',
        '--cut-border-right': this.cutLeft ? '1px' : 0,
        '--cut-border-bottom': this.cutTop ? '1px' : 0,
        '--cut-border-left': this.cutLeft ? 0 : '1px',
      }
    },
    cutTop() {
      return this.cutTopLeft || this.cutTopRight
    },
    cutLeft() {
      return this.cutTopLeft || this.cutBottomLeft
    },
  },
})
